import React, {useEffect, useState} from 'react'
import { jsonResponseHandler } from '../../../utils/FetchHelper'
import MenuSelectForm from "./MenuSelectForm";
import { addPrefix } from "../../../utils/UriUtil"
import {useDispatch} from "react-redux"

export default function PageDetailForm({onChange, onFocus, onBlur}) {
  const dispatch = useDispatch()
  const [initialized, setInitialized] = useState(false)
  const [selected, setSelected] = useState(null)
  const [pages, setPages] = useState([])

  function handleSelect(item) {
    let selectedItem = pages.find(page => page.id === item.value)
    setSelected(selectedItem)
    onChange(14, selectedItem.slogan)
  }

  useEffect(() => {
    fetch(addPrefix("/manage/pages.json"), {
      credentials: "include",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        let defaultSelected = data.items && data.items.length > 0 && data.items[0]
        setPages(data.items)
        setSelected(defaultSelected)
        setInitialized(true)
        onChange(14, defaultSelected.slogan)
      })
      .catch(e => {
        console.error(e)
        alert("문제가 발생했습니다.")
      })
  }, [])

  if (!initialized) {
    return (
      <span className="lab_menu">로딩 중</span>
    )
  } else if(!pages || pages.length === 0) {
    return (
      <span className="lab_menu">페이지가 없습니다.</span>
    )
  } else {
    return (
      <MenuSelectForm className="opt_menu opt_menu2" items={
        pages.map(item => ({ label:item.title, value:item.id }))
      } selected={selected.id} onSelect={handleSelect} onFocus={onFocus} onBlur={onBlur} />
    )
  }
}
